module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-process"
  }, [_c('h3', [_vm._v("Ons schadeproces")]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('step1schademelden-component', {
    attrs: {
      "ctx": _vm.ctx,
      "schademeldenurl": _vm.schademeldenurl
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-item"
  }, [_c('div', {
    staticClass: "hexagon-thick"
  }, [_c('p', {
    staticClass: "icon icon-archive clean"
  })]), _vm._v(" "), _c('h4', [_vm._v("In behandeling")]), _vm._v(" "), _c('p', [_vm._v("Wij nemen uw schademelding in behandeling.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-item"
  }, [_c('div', {
    staticClass: "hexagon-thick"
  }, [_c('p', {
    staticClass: "icon icon-user clean"
  })]), _vm._v(" "), _c('h4', [_vm._v("Wacht op uw reactie")]), _vm._v(" "), _c('p', [_vm._v("Voor de afhandeling van uw schade hebben wij aanvullende gegevens van u nodig. Hiervan ontvangt u van ons bericht per e-mail en in uw berichtenbox.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-item"
  }, [_c('div', {
    staticClass: "hexagon-thick"
  }, [_c('p', {
    staticClass: "icon icon-shield clean"
  })]), _vm._v(" "), _c('h4', [_vm._v("Beoordeling")]), _vm._v(" "), _c('p', [_vm._v("Zodra alle gegevens bekend zijn, wordt de schade beoordeeld en z.s.m. afgewikkeld.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-item"
  }, [_c('div', {
    staticClass: "hexagon-thick"
  }, [_c('p', {
    staticClass: "icon icon-check clean"
  })]), _vm._v(" "), _c('h4', [_vm._v("Afgehandeld")]), _vm._v(" "), _c('p', [_vm._v("Wij hebben uw dossier gesloten of doorgestuurd naar de behandelend verzekeraar.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a6056c0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/schade/defaultproces.vue
// module id = 96
// module chunks = 0